﻿import { KboOutput } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { FileOutput } from "@models/configurators/outputs/file-output";
import { IOutput, ISceneRenderOutput } from "@models/entity-models";
import { eExportType, eOutputType } from "@models/enums";
import { RenderPassExport } from "./render-pass-export";

@KboOutput(CToken.SceneRenderOutput, eOutputType.sceneRender)
export class SceneRenderOutput extends FileOutput implements ISceneRenderOutput {
    constructor(kom: KbObjectManager, args?: IOutput) {
        super(kom, args);
        this.type = eOutputType.sceneRender;
    }

    public pass: string;
    public idScene: number;
    public width: number;
    public height: number;

    public addRenderPass(): RenderPassExport {
        let exprt = new RenderPassExport(this.$manager);
        exprt.type = eExportType.png;
        exprt.name = "Render Pass";
        this.$manager.addKbObject(exprt, this);
        this.exports.push(exprt);
        return exprt;
    }
}
